import * as React from 'react';
import { FormField } from '@cian/ui-kit';
import { CardsQuestion } from '../../components/CardsQuestion';
import { useOneChoiceFormField } from '../../utils/hooks/useOneChoiceFormField';
import { jsx as _jsx } from "react/jsx-runtime";
export var CardsQuestionContainer = function CardsQuestionContainer(props) {
  var answers = props.answers,
    subType = props.subType;
  var _useOneChoiceFormFiel = useOneChoiceFormField({
      name: props.name
    }),
    handleSelect = _useOneChoiceFormFiel.handleSelect,
    value = _useOneChoiceFormFiel.value,
    error = _useOneChoiceFormFiel.error,
    touched = _useOneChoiceFormFiel.touched;
  if (!answers) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormField, {
    label: props.label,
    errorMessage: touched ? error : null,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(CardsQuestion, {
      handleSelect: handleSelect,
      iconType: subType,
      cards: answers,
      value: value
    })
  });
};
CardsQuestionContainer.displayName = 'CardsQuestionContainer';